export default __webpack_public_path__ + "static/media/gmetrix-logo-hover.37f26874.svg";